import { customFetch } from '../api/custom-fetch';
export const getValidateJoinCodeUrl = (joinCode) => {
    return `/v1/events/validate/${joinCode}`;
};
export const validateJoinCode = async (joinCode, options) => {
    return customFetch(getValidateJoinCodeUrl(joinCode), {
        ...options,
        method: 'GET'
    });
};
export const getSearchSchoolsUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value === null) {
            normalizedParams.append(key, 'null');
        }
        else if (value !== undefined) {
            normalizedParams.append(key, value.toString());
        }
    });
    return `/v1/schools?${normalizedParams.toString()}`;
};
export const searchSchools = async (params, options) => {
    return customFetch(getSearchSchoolsUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getCreateRegistrationUrl = () => {
    return `/v1/registration`;
};
export const createRegistration = async (createRegistration, options) => {
    return customFetch(getCreateRegistrationUrl(), {
        ...options,
        method: 'POST',
        body: JSON.stringify(createRegistration)
    });
};
export const getRecoverRegistrationUrl = () => {
    return `/v1/registration/recover`;
};
export const recoverRegistration = async (recoverRegistrationBody, options) => {
    return customFetch(getRecoverRegistrationUrl(), {
        ...options,
        method: 'POST',
        body: JSON.stringify(recoverRegistrationBody)
    });
};
export const getCreateSurveyResponseUrl = () => {
    return `/v1/surveyResponses`;
};
export const createSurveyResponse = async (surveyResponseRequest, options) => {
    return customFetch(getCreateSurveyResponseUrl(), {
        ...options,
        method: 'POST',
        body: JSON.stringify(surveyResponseRequest)
    });
};
export const getCreateRegistrationSurveyResponseUrl = () => {
    return `/v1/registrationSurveyResponses`;
};
export const createRegistrationSurveyResponse = async (registrationSurveyResponseRequest, options) => {
    return customFetch(getCreateRegistrationSurveyResponseUrl(), {
        ...options,
        method: 'POST',
        body: JSON.stringify(registrationSurveyResponseRequest)
    });
};
export const getRecordGamePlayUrl = () => {
    return `/v1/gamePlays`;
};
export const recordGamePlay = async (recordGamePlayRequest, options) => {
    return customFetch(getRecordGamePlayUrl(), {
        ...options,
        method: 'POST',
        body: JSON.stringify(recordGamePlayRequest)
    });
};
